export default __webpack_public_path__ + "static/media/popup_close.16972c04.svg";